export default "__VITE_ASSET__QR5ISeaA__"